import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles

import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import NProgress from 'vue-nprogress'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './localization'
import './antd'
import './registerServiceWorker'

// mocking api
import './services/axios/fakeApi'
// apollo
import VueApollo from 'vue-apollo'
import apolloClient from './apolloClient'
// cognito
import cognito from './cognito/'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(VueApollo)
Vue.use(NProgress)
Vue.use(require('vue-cookies'))
Vue.use(VuePageTitle, {
  prefix: 'Taxi Contigo',
  router,
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
  },
})

Vue.config.productionTip = false
Vue.$cookies.config('30d')
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  apolloProvider,
  cognito,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app')
